import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30120e08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  className: "absolute top-24 items-center px-4 flex justify-center w-full",
  style: {"z-index":"1000"}
}
const _hoisted_2 = { className: "relative mr-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "z-10 leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-gray-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    })
  ])
], -1))
const _hoisted_4 = { class: "h-full" }
const _hoisted_5 = { class: "relative max-w-[340px] mx-auto bg-white shadow-lg rounded-lg grid grid-cols-1 lg:grid-cols-2" }
const _hoisted_6 = { class: "py-3 px-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xs font-semibold uppercase text-gray-400 mb-1" }, "Artists", -1))
const _hoisted_8 = { class: "divide-y divide-gray-200" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative inline-flex flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "text-gray-400 hover:text-gray-500 rounded-full focus:ring-0 outline-none focus:outline-none" }, [
    /*#__PURE__*/_createElementVNode("span", null, "See all")
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xs font-semibold uppercase text-gray-400 mb-1 mt-8" }, "Genres", -1))
const _hoisted_14 = { class: "divide-y divide-gray-200" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative inline-flex flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "text-gray-400 hover:text-gray-500 rounded-full focus:ring-0 outline-none focus:outline-none" }, [
    /*#__PURE__*/_createElementVNode("span", null, "See all")
  ])
], -1))
const _hoisted_18 = { class: "py-3 px-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xs font-semibold uppercase text-gray-400 mb-1" }, "Lyrics", -1))
const _hoisted_20 = { class: "flex flex-wrap items-center content-start justify-start flex-row" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex justify-between items-center mb-3" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = {
  class: "inline-flex items-start mr-3",
  href: "#"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "pr-1" }
const _hoisted_27 = { class: "inline-flex text-gray-800 hover:text-gray-900 justify-start" }
const _hoisted_28 = { class: "text-xl leading-snug font-bold text-ellipsis overflow-hidden" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-wrap justify-center sm:justify-start space-x-4\" data-v-30120e08><div class=\"flex items-center\" data-v-30120e08><svg class=\"w-4 h-4 fill-current flex-shrink-0 text-gray-400\" xmlns=\"http://www.w3.org/2000/svg\" width=\"1em\" height=\"1em\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\" data-v-30120e08><g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-30120e08><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-30120e08></circle><path d=\"m15 16l-2.414-2.414A2 2 0 0 1 12 12.172V6\" data-v-30120e08></path></g></svg><small class=\"text-xs whitespace-nowrap ml-2\" data-v-30120e08>played 2 hours ago</small></div><div class=\"flex items-center\" data-v-30120e08><div class=\"text-sm font-medium whitespace-nowrap text-indigo-500 hover:text-indigo-600 ml-2\" data-v-30120e08>rock</div></div></div>", 1)
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative inline-flex flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "text-gray-400 hover:text-gray-500 rounded-full focus:ring-0 outline-none focus:outline-none" }, [
    /*#__PURE__*/_createElementVNode("span", null, "See all")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "text",
        onKeyup: _cache[0] || (_cache[0] = ({ target: { value } }) => { _ctx.debounce(value); _ctx.showOptions = true }),
        onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFocus(true))),
        onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFocus(false))),
        autocomplete: "off",
        class: "block p-2 pl-10 w-70 text-5xl mr-8 text-gray-900 bg-white rounded-lg border border-gray-300 focus:pl-3",
        placeholder: "Search by artist, genre, anime..."
      }, null, 32),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("section", {
          class: "flex flex-col justify-start antialiased bg-gray-50 text-gray-600 min-h-screen p-4 absolute items-center px-4 w-full",
          onMouseover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hoveringSearchBox && _ctx.hoveringSearchBox(...args))),
          onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isHovering = false))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.artists, (art) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: art.id,
                      class: "w-full text-left py-2 focus:outline-none focus-visible:bg-indigo-50"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          class: "rounded-full items-start flex-shrink-0 mr-3",
                          src: art.thumbnailAbsoluteUrl,
                          width: "32",
                          height: "32",
                          alt: art.name
                        }, null, 8, _hoisted_10),
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", _hoisted_11, _toDisplayString(art.name), 1),
                          _createElementVNode("small", null, _toDisplayString(art.artist) + " · " + _toDisplayString(art.totallyrics), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.genres, (genre) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: genre.id,
                      class: "w-full text-left py-2 focus:outline-none focus-visible:bg-indigo-50"
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", _hoisted_16, _toDisplayString(genre.title), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.lyrics, (lyric) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: lyric.id,
                      class: "w-full pt-4 pb-4 px-4 border-b border-gray-200 hover:bg-gray-200 cursor-pointer lyrics-item",
                      onClick: ($event: any) => (_ctx.select(lyric.id))
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("a", _hoisted_24, [
                            _createElementVNode("img", {
                              class: "rounded-full",
                              src: lyric.thumbnailAbsoluteUrl,
                              width: "48",
                              height: "48",
                              alt: "Lauren Marsano"
                            }, null, 8, _hoisted_25)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("h2", _hoisted_28, _toDisplayString(lyric.songTitle), 1)
                            ]),
                            _createElementVNode("a", {
                              class: "block text-sm font-medium hover:text-indigo-500",
                              onClick: ($event: any) => (_ctx.goToBand(lyric))
                            }, _toDisplayString(lyric.bandName), 9, _hoisted_29)
                          ])
                        ])
                      ]),
                      _hoisted_30
                    ], 8, _hoisted_21))
                  }), 128))
                ]),
                _hoisted_31
              ])
            ])
          ])
        ], 32)
      ], 512), [
        [_vShow, _ctx.results && _ctx.showOptions]
      ])
    ])
  ]))
}